export function UpdateOffset(state, option) {
  let result = {
    offsetX: state.offsetX,
    offsetY: state.offsetY,
    spacing: state.spacing,
  };
  if (
    !state.autoZoom ||
    !state.entities[0].details ||
    state.entities[0].details.length === 0
  ) {
    return result;
  }

  let newSpacing = state.spacing;
  let newOffsetX = state.offsetX;
  let newOffsetY = state.offsetY;
  let windowWidth = state.windowWidth;
  let windowHeight = state.windowHeight;
  let spacing = state.spacing;
  let entities = state.entities[0].details;

  let xmin = 0;
  let ymin = 0;
  let xmax = 0;
  let ymax = 0;

  if (state.fullExtent && !option) {
    xmin = entities[state.fullExtent[0]].coordinates[0][0];
    xmax = entities[state.fullExtent[0]].coordinates[0][0];
    ymin = entities[state.fullExtent[0]].coordinates[0][1];
    ymax = entities[state.fullExtent[0]].coordinates[0][1];
    for (let x = 0; x < state.fullExtent.length; x++) {
      for (
        let y = 0;
        y < entities[state.fullExtent[x]].coordinates.length;
        y++
      ) {
        if (entities[state.fullExtent[x]].coordinates[y][0] < xmin) {
          xmin = entities[state.fullExtent[x]].coordinates[y][0];
        }
        if (entities[state.fullExtent[x]].coordinates[y][0] > xmax) {
          xmax = entities[state.fullExtent[x]].coordinates[y][0];
        }
        if (entities[state.fullExtent[x]].coordinates[y][1] < ymin) {
          ymin = entities[state.fullExtent[x]].coordinates[y][1];
        }
        if (entities[state.fullExtent[x]].coordinates[y][1] > ymax) {
          ymax = entities[state.fullExtent[x]].coordinates[y][1];
        }
      }
    }
  } else {
    xmin = entities[0].coordinates[0][0];
    xmax = entities[0].coordinates[0][0];
    ymin = entities[0].coordinates[0][1];
    ymax = entities[0].coordinates[0][1];

    for (let x = 0; x < entities.length; x++) {
      for (let y = 0; y < entities[x].coordinates.length; y++) {
        if (entities[x].coordinates[y][0] < xmin) {
          xmin = entities[x].coordinates[y][0];
        }
        if (entities[x].coordinates[y][0] > xmax) {
          xmax = entities[x].coordinates[y][0];
        }
        if (entities[x].coordinates[y][1] < ymin) {
          ymin = entities[x].coordinates[y][1];
        }
        if (entities[x].coordinates[y][1] > ymax) {
          ymax = entities[x].coordinates[y][1];
        }
      }
    }
  }

  let xdiff = xmax - xmin;
  let ydiff = ymax - ymin;
  let adjustedxmin = ((xmin + state.offsetX) / 10) * spacing;
  let adjustedxmax = ((xmax + state.offsetX) / 10) * spacing;
  let adjustedymin = ((ymin + state.offsetY) / 10) * spacing;
  let adjustedymax = ((ymax + state.offsetY) / 10) * spacing;

  let adjustedxdiff = (xdiff / 10) * spacing;
  let adjustedydiff = (ydiff / 10) * spacing;

  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //

  let xunits = xdiff / 10;
  let yunits = ydiff / 10;
  let xwindowunits = Math.floor(windowWidth / spacing);
  let ywindowunits = Math.floor(windowHeight / spacing);

  if (adjustedxdiff > windowWidth || adjustedydiff > windowHeight) {
    for(let x=15;x>0;x-=0.5) {
      if (
        ((xdiff + 50) / 10) * x < windowWidth &&
        ((ydiff + 50) / 10) * x < windowHeight
      ) {
        newSpacing = x;
        xwindowunits = Math.floor(windowWidth / newSpacing);
        ywindowunits = Math.floor(windowHeight / newSpacing);
        newOffsetX = (xmin - 10) * -1;
        newOffsetX = Math.floor((xwindowunits - xunits) / 2) * 10 - xmin;
        newOffsetY = (ymin - 10) * -1;
        newOffsetY = Math.floor((ywindowunits - yunits) / 2) * 10 - ymin;
        x = 0;
      }
    }
  } else if (
    adjustedxmin < 0 ||
    adjustedxmax > windowWidth ||
    adjustedymin < 0 ||
    adjustedymax > windowHeight
  ) {
    newSpacing = state.spacing;
    xwindowunits = Math.floor(windowWidth / newSpacing);
    ywindowunits = Math.floor(windowHeight / newSpacing);
    newOffsetX = (xmin - 10) * -1;
    newOffsetX = Math.floor((xwindowunits - xunits) / 2) * 10 - xmin;
    newOffsetY = (ymin - 10) * -1;
    newOffsetY = Math.floor((ywindowunits - yunits) / 2) * 10 - ymin;
  }

  // let minx = entities[0].details[0].coordinates[0][0];
  // let maxx = entities[0].details[0].coordinates[0][0];
  // let miny = entities[0].details[0].coordinates[0][1];
  // let maxy = entities[0].details[0].coordinates[0][1];
  // for(let x=0;x<entities[0].details.length;x++){
  //     for(let y=0;y<entities[0].details[x].coordinates.length;y++){
  //         if(entities[0].details[x].coordinates[y][0]<minx){
  //             minx = entities[0].details[x].coordinates[y][0];
  //         }
  //         if(entities[0].details[x].coordinates[y][0]>maxx){
  //             maxx = entities[0].details[x].coordinates[y][0];
  //         }
  //         if(entities[0].details[x].coordinates[y][1]<miny){
  //             miny = entities[0].details[x].coordinates[y][1];
  //         }
  //         if(entities[0].details[x].coordinates[y][1]>maxy){
  //             maxy = entities[0].details[x].coordinates[y][1];
  //         }
  //     }
  // }
  //
  //
  // let xDiff = maxx-minx;
  // let yDiff = maxy-miny;
  // if(xDiff+20<windowWidth && yDiff+20<windowHeight){
  //
  //     if(minx+offsetX<0 && minx>=0){
  //
  //
  //         result.offsetX = 0;
  //     }
  //     if(miny+offsetY<0 && miny>=0){
  //
  //
  //         result.offsetY = 0;
  //     }
  //     if(maxy+offsetY>windowHeight && maxy<=windowHeight){
  //
  //         result.offsetY = 0;
  //     }
  //     if(maxx+offsetX>windowWidth && maxx<=windowWidth){
  //
  //         result.offsetX = 0;
  //     }
  // }
  // else{
  //
  //     result.spacing = 8;
  // }
  //

  result = {
    offsetX: newOffsetX,
    offsetY: newOffsetY,
    spacing: newSpacing,
  };
  return result;
}
